'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "themeContainer": "Polaris-ThemeProvider--themeContainer"
};

exports.default = styles;
